import React from 'react';

import { ReactComponent as Spinner } from '../../assets/img/spinner/spinner.svg';
import { useAppSelector } from '../../hooks/useAppSelector';
import { selectOpen } from '../../selectors/drawerSelector';
import { isDialogOpen } from '../../selectors/dialogSelector';
import ThemeConstants from '../../theme/ThemeConstants';

import './style.css';

interface ILoaderProps {
  show: boolean;
}

const Loader = ({ show }: ILoaderProps) => {
  const open = useAppSelector(selectOpen);
  const openDialog = useAppSelector(isDialogOpen);

  return (
    <div
      className={show ? 'spinner-container' : 'spinner-container spinner-hide'}
    >
      <Spinner
        fill={
          open && !openDialog
            ? ThemeConstants.secondary.main
            : ThemeConstants.primary.main
        }
      />
    </div>
  );
};
export default Loader;
